var _createClass = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _classCallCheck = require("/opt/build/repo/web/node_modules/@babel/runtime/helpers/classCallCheck");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/*! bittorrent-protocol. MIT License. WebTorrent LLC <https://webtorrent.io/opensource> */
var arrayRemove = require('unordered-array-remove');

var bencode = require('bencode');

var BitField = require('bitfield').default;

var debug = require('debug')('bittorrent-protocol');

var randombytes = require('randombytes');

var speedometer = require('speedometer');

var stream = require('readable-stream');

var BITFIELD_GROW = 400000;
var KEEP_ALIVE_TIMEOUT = 55000;
var MESSAGE_PROTOCOL = Buffer.from("\x13BitTorrent protocol");
var MESSAGE_KEEP_ALIVE = Buffer.from([0x00, 0x00, 0x00, 0x00]);
var MESSAGE_CHOKE = Buffer.from([0x00, 0x00, 0x00, 0x01, 0x00]);
var MESSAGE_UNCHOKE = Buffer.from([0x00, 0x00, 0x00, 0x01, 0x01]);
var MESSAGE_INTERESTED = Buffer.from([0x00, 0x00, 0x00, 0x01, 0x02]);
var MESSAGE_UNINTERESTED = Buffer.from([0x00, 0x00, 0x00, 0x01, 0x03]);
var MESSAGE_RESERVED = [0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00];
var MESSAGE_PORT = [0x00, 0x00, 0x00, 0x03, 0x09, 0x00, 0x00];

var Request = function Request(piece, offset, length, callback) {
  "use strict";

  _classCallCheck(this, Request);

  this.piece = piece;
  this.offset = offset;
  this.length = length;
  this.callback = callback;
};

var Wire = /*#__PURE__*/function (_stream$Duplex) {
  "use strict";

  _inherits(Wire, _stream$Duplex);

  var _super = _createSuper(Wire);

  function Wire() {
    var _this;

    _classCallCheck(this, Wire);

    _this = _super.call(this);
    _this._debugId = randombytes(4).toString('hex');

    _this._debug('new wire');

    _this.peerId = null; // remote peer id (hex string)

    _this.peerIdBuffer = null; // remote peer id (buffer)

    _this.type = null; // connection type ('webrtc', 'tcpIncoming', 'tcpOutgoing', 'webSeed')

    _this.amChoking = true; // are we choking the peer?

    _this.amInterested = false; // are we interested in the peer?

    _this.peerChoking = true; // is the peer choking us?

    _this.peerInterested = false; // is the peer interested in us?
    // The largest torrent that I know of (the Geocities archive) is ~641 GB and has
    // ~41,000 pieces. Therefore, cap bitfield to 10x larger (400,000 bits) to support all
    // possible torrents but prevent malicious peers from growing bitfield to fill memory.

    _this.peerPieces = new BitField(0, {
      grow: BITFIELD_GROW
    });
    _this.peerExtensions = {};
    _this.requests = []; // outgoing

    _this.peerRequests = []; // incoming

    _this.extendedMapping = {}; // number -> string, ex: 1 -> 'ut_metadata'

    _this.peerExtendedMapping = {}; // string -> number, ex: 9 -> 'ut_metadata'
    // The extended handshake to send, minus the "m" field, which gets automatically
    // filled from `this.extendedMapping`

    _this.extendedHandshake = {};
    _this.peerExtendedHandshake = {}; // remote peer's extended handshake

    _this._ext = {}; // string -> function, ex 'ut_metadata' -> ut_metadata()

    _this._nextExt = 1;
    _this.uploaded = 0;
    _this.downloaded = 0;
    _this.uploadSpeed = speedometer();
    _this.downloadSpeed = speedometer();
    _this._keepAliveInterval = null;
    _this._timeout = null;
    _this._timeoutMs = 0;
    _this.destroyed = false; // was the wire ended by calling `destroy`?

    _this._finished = false;
    _this._parserSize = 0; // number of needed bytes to parse next message from remote peer

    _this._parser = null; // function to call once `this._parserSize` bytes are available

    _this._buffer = []; // incomplete message data

    _this._bufferSize = 0; // cached total length of buffers in `this._buffer`

    _this.once('finish', function () {
      return _this._onFinish();
    });

    _this._parseHandshake();

    return _this;
  }
  /**
   * Set whether to send a "keep-alive" ping (sent every 55s)
   * @param {boolean} enable
   */


  _createClass(Wire, [{
    key: "setKeepAlive",
    value: function setKeepAlive(enable) {
      var _this2 = this;

      this._debug('setKeepAlive %s', enable);

      clearInterval(this._keepAliveInterval);
      if (enable === false) return;
      this._keepAliveInterval = setInterval(function () {
        _this2.keepAlive();
      }, KEEP_ALIVE_TIMEOUT);
    }
    /**
     * Set the amount of time to wait before considering a request to be "timed out"
     * @param {number} ms
     * @param {boolean=} unref (should the timer be unref'd? default: false)
     */

  }, {
    key: "setTimeout",
    value: function setTimeout(ms, unref) {
      this._debug('setTimeout ms=%d unref=%s', ms, unref);

      this._clearTimeout();

      this._timeoutMs = ms;
      this._timeoutUnref = !!unref;

      this._updateTimeout();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.destroyed) return;
      this.destroyed = true;

      this._debug('destroy');

      this.emit('close');
      this.end();
    }
  }, {
    key: "end",
    value: function end() {
      var _get2;

      this._debug('end');

      this._onUninterested();

      this._onChoke();

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_get2 = _get(_getPrototypeOf(Wire.prototype), "end", this)).call.apply(_get2, [this].concat(args));
    }
    /**
     * Use the specified protocol extension.
     * @param  {function} Extension
     */

  }, {
    key: "use",
    value: function use(Extension) {
      var name = Extension.prototype.name;

      if (!name) {
        throw new Error('Extension class requires a "name" property on the prototype');
      }

      this._debug('use extension.name=%s', name);

      var ext = this._nextExt;
      var handler = new Extension(this);

      function noop() {}

      if (typeof handler.onHandshake !== 'function') {
        handler.onHandshake = noop;
      }

      if (typeof handler.onExtendedHandshake !== 'function') {
        handler.onExtendedHandshake = noop;
      }

      if (typeof handler.onMessage !== 'function') {
        handler.onMessage = noop;
      }

      this.extendedMapping[ext] = name;
      this._ext[name] = handler;
      this[name] = handler;
      this._nextExt += 1;
    } //
    // OUTGOING MESSAGES
    //

    /**
     * Message "keep-alive": <len=0000>
     */

  }, {
    key: "keepAlive",
    value: function keepAlive() {
      this._debug('keep-alive');

      this._push(MESSAGE_KEEP_ALIVE);
    }
    /**
     * Message: "handshake" <pstrlen><pstr><reserved><info_hash><peer_id>
     * @param  {Buffer|string} infoHash (as Buffer or *hex* string)
     * @param  {Buffer|string} peerId
     * @param  {Object} extensions
     */

  }, {
    key: "handshake",
    value: function handshake(infoHash, peerId, extensions) {
      var infoHashBuffer;
      var peerIdBuffer;

      if (typeof infoHash === 'string') {
        infoHash = infoHash.toLowerCase();
        infoHashBuffer = Buffer.from(infoHash, 'hex');
      } else {
        infoHashBuffer = infoHash;
        infoHash = infoHashBuffer.toString('hex');
      }

      if (typeof peerId === 'string') {
        peerIdBuffer = Buffer.from(peerId, 'hex');
      } else {
        peerIdBuffer = peerId;
        peerId = peerIdBuffer.toString('hex');
      }

      if (infoHashBuffer.length !== 20 || peerIdBuffer.length !== 20) {
        throw new Error('infoHash and peerId MUST have length 20');
      }

      this._debug('handshake i=%s p=%s exts=%o', infoHash, peerId, extensions);

      var reserved = Buffer.from(MESSAGE_RESERVED); // enable extended message

      reserved[5] |= 0x10;
      if (extensions && extensions.dht) reserved[7] |= 1;

      this._push(Buffer.concat([MESSAGE_PROTOCOL, reserved, infoHashBuffer, peerIdBuffer]));

      this._handshakeSent = true;

      if (this.peerExtensions.extended && !this._extendedHandshakeSent) {
        // Peer's handshake indicated support already
        // (incoming connection)
        this._sendExtendedHandshake();
      }
    }
    /* Peer supports BEP-0010, send extended handshake.
     *
     * This comes after the 'handshake' event to give the user a chance to populate
     * `this.extendedHandshake` and `this.extendedMapping` before the extended handshake
     * is sent to the remote peer.
     */

  }, {
    key: "_sendExtendedHandshake",
    value: function _sendExtendedHandshake() {
      // Create extended message object from registered extensions
      var msg = Object.assign({}, this.extendedHandshake);
      msg.m = {};

      for (var ext in this.extendedMapping) {
        var name = this.extendedMapping[ext];
        msg.m[name] = Number(ext);
      } // Send extended handshake


      this.extended(0, bencode.encode(msg));
      this._extendedHandshakeSent = true;
    }
    /**
     * Message "choke": <len=0001><id=0>
     */

  }, {
    key: "choke",
    value: function choke() {
      if (this.amChoking) return;
      this.amChoking = true;

      this._debug('choke');

      while (this.peerRequests.length) {
        this.peerRequests.pop();
      }

      this._push(MESSAGE_CHOKE);
    }
    /**
     * Message "unchoke": <len=0001><id=1>
     */

  }, {
    key: "unchoke",
    value: function unchoke() {
      if (!this.amChoking) return;
      this.amChoking = false;

      this._debug('unchoke');

      this._push(MESSAGE_UNCHOKE);
    }
    /**
     * Message "interested": <len=0001><id=2>
     */

  }, {
    key: "interested",
    value: function interested() {
      if (this.amInterested) return;
      this.amInterested = true;

      this._debug('interested');

      this._push(MESSAGE_INTERESTED);
    }
    /**
     * Message "uninterested": <len=0001><id=3>
     */

  }, {
    key: "uninterested",
    value: function uninterested() {
      if (!this.amInterested) return;
      this.amInterested = false;

      this._debug('uninterested');

      this._push(MESSAGE_UNINTERESTED);
    }
    /**
     * Message "have": <len=0005><id=4><piece index>
     * @param  {number} index
     */

  }, {
    key: "have",
    value: function have(index) {
      this._debug('have %d', index);

      this._message(4, [index], null);
    }
    /**
     * Message "bitfield": <len=0001+X><id=5><bitfield>
     * @param  {BitField|Buffer} bitfield
     */

  }, {
    key: "bitfield",
    value: function bitfield(_bitfield) {
      this._debug('bitfield');

      if (!Buffer.isBuffer(_bitfield)) _bitfield = _bitfield.buffer;

      this._message(5, [], _bitfield);
    }
    /**
     * Message "request": <len=0013><id=6><index><begin><length>
     * @param  {number}   index
     * @param  {number}   offset
     * @param  {number}   length
     * @param  {function} cb
     */

  }, {
    key: "request",
    value: function request(index, offset, length, cb) {
      if (!cb) cb = function cb() {};
      if (this._finished) return cb(new Error('wire is closed'));
      if (this.peerChoking) return cb(new Error('peer is choking'));

      this._debug('request index=%d offset=%d length=%d', index, offset, length);

      this.requests.push(new Request(index, offset, length, cb));

      this._updateTimeout();

      this._message(6, [index, offset, length], null);
    }
    /**
     * Message "piece": <len=0009+X><id=7><index><begin><block>
     * @param  {number} index
     * @param  {number} offset
     * @param  {Buffer} buffer
     */

  }, {
    key: "piece",
    value: function piece(index, offset, buffer) {
      this._debug('piece index=%d offset=%d', index, offset);

      this.uploaded += buffer.length;
      this.uploadSpeed(buffer.length);
      this.emit('upload', buffer.length);

      this._message(7, [index, offset], buffer);
    }
    /**
     * Message "cancel": <len=0013><id=8><index><begin><length>
     * @param  {number} index
     * @param  {number} offset
     * @param  {number} length
     */

  }, {
    key: "cancel",
    value: function cancel(index, offset, length) {
      this._debug('cancel index=%d offset=%d length=%d', index, offset, length);

      this._callback(this._pull(this.requests, index, offset, length), new Error('request was cancelled'), null);

      this._message(8, [index, offset, length], null);
    }
    /**
     * Message: "port" <len=0003><id=9><listen-port>
     * @param {Number} port
     */

  }, {
    key: "port",
    value: function port(_port) {
      this._debug('port %d', _port);

      var message = Buffer.from(MESSAGE_PORT);
      message.writeUInt16BE(_port, 5);

      this._push(message);
    }
    /**
     * Message: "extended" <len=0005+X><id=20><ext-number><payload>
     * @param  {number|string} ext
     * @param  {Object} obj
     */

  }, {
    key: "extended",
    value: function extended(ext, obj) {
      this._debug('extended ext=%s', ext);

      if (typeof ext === 'string' && this.peerExtendedMapping[ext]) {
        ext = this.peerExtendedMapping[ext];
      }

      if (typeof ext === 'number') {
        var extId = Buffer.from([ext]);
        var buf = Buffer.isBuffer(obj) ? obj : bencode.encode(obj);

        this._message(20, [], Buffer.concat([extId, buf]));
      } else {
        throw new Error("Unrecognized extension: ".concat(ext));
      }
    }
    /**
     * Duplex stream method. Called whenever the remote peer stream wants data. No-op
     * since we'll just push data whenever we get it.
     */

  }, {
    key: "_read",
    value: function _read() {}
    /**
     * Send a message to the remote peer.
     */

  }, {
    key: "_message",
    value: function _message(id, numbers, data) {
      var dataLength = data ? data.length : 0;
      var buffer = Buffer.allocUnsafe(5 + 4 * numbers.length);
      buffer.writeUInt32BE(buffer.length + dataLength - 4, 0);
      buffer[4] = id;

      for (var i = 0; i < numbers.length; i++) {
        buffer.writeUInt32BE(numbers[i], 5 + 4 * i);
      }

      this._push(buffer);

      if (data) this._push(data);
    }
  }, {
    key: "_push",
    value: function _push(data) {
      if (this._finished) return;
      return this.push(data);
    } //
    // INCOMING MESSAGES
    //

  }, {
    key: "_onKeepAlive",
    value: function _onKeepAlive() {
      this._debug('got keep-alive');

      this.emit('keep-alive');
    }
  }, {
    key: "_onHandshake",
    value: function _onHandshake(infoHashBuffer, peerIdBuffer, extensions) {
      var infoHash = infoHashBuffer.toString('hex');
      var peerId = peerIdBuffer.toString('hex');

      this._debug('got handshake i=%s p=%s exts=%o', infoHash, peerId, extensions);

      this.peerId = peerId;
      this.peerIdBuffer = peerIdBuffer;
      this.peerExtensions = extensions;
      this.emit('handshake', infoHash, peerId, extensions);
      var name;

      for (name in this._ext) {
        this._ext[name].onHandshake(infoHash, peerId, extensions);
      }

      if (extensions.extended && this._handshakeSent && !this._extendedHandshakeSent) {
        // outgoing connection
        this._sendExtendedHandshake();
      }
    }
  }, {
    key: "_onChoke",
    value: function _onChoke() {
      this.peerChoking = true;

      this._debug('got choke');

      this.emit('choke');

      while (this.requests.length) {
        this._callback(this.requests.pop(), new Error('peer is choking'), null);
      }
    }
  }, {
    key: "_onUnchoke",
    value: function _onUnchoke() {
      this.peerChoking = false;

      this._debug('got unchoke');

      this.emit('unchoke');
    }
  }, {
    key: "_onInterested",
    value: function _onInterested() {
      this.peerInterested = true;

      this._debug('got interested');

      this.emit('interested');
    }
  }, {
    key: "_onUninterested",
    value: function _onUninterested() {
      this.peerInterested = false;

      this._debug('got uninterested');

      this.emit('uninterested');
    }
  }, {
    key: "_onHave",
    value: function _onHave(index) {
      if (this.peerPieces.get(index)) return;

      this._debug('got have %d', index);

      this.peerPieces.set(index, true);
      this.emit('have', index);
    }
  }, {
    key: "_onBitField",
    value: function _onBitField(buffer) {
      this.peerPieces = new BitField(buffer);

      this._debug('got bitfield');

      this.emit('bitfield', this.peerPieces);
    }
  }, {
    key: "_onRequest",
    value: function _onRequest(index, offset, length) {
      var _this3 = this;

      if (this.amChoking) return;

      this._debug('got request index=%d offset=%d length=%d', index, offset, length);

      var respond = function respond(err, buffer) {
        if (request !== _this3._pull(_this3.peerRequests, index, offset, length)) return;
        if (err) return _this3._debug('error satisfying request index=%d offset=%d length=%d (%s)', index, offset, length, err.message);

        _this3.piece(index, offset, buffer);
      };

      var request = new Request(index, offset, length, respond);
      this.peerRequests.push(request);
      this.emit('request', index, offset, length, respond);
    }
  }, {
    key: "_onPiece",
    value: function _onPiece(index, offset, buffer) {
      this._debug('got piece index=%d offset=%d', index, offset);

      this._callback(this._pull(this.requests, index, offset, buffer.length), null, buffer);

      this.downloaded += buffer.length;
      this.downloadSpeed(buffer.length);
      this.emit('download', buffer.length);
      this.emit('piece', index, offset, buffer);
    }
  }, {
    key: "_onCancel",
    value: function _onCancel(index, offset, length) {
      this._debug('got cancel index=%d offset=%d length=%d', index, offset, length);

      this._pull(this.peerRequests, index, offset, length);

      this.emit('cancel', index, offset, length);
    }
  }, {
    key: "_onPort",
    value: function _onPort(port) {
      this._debug('got port %d', port);

      this.emit('port', port);
    }
  }, {
    key: "_onExtended",
    value: function _onExtended(ext, buf) {
      if (ext === 0) {
        var info;

        try {
          info = bencode.decode(buf);
        } catch (err) {
          this._debug('ignoring invalid extended handshake: %s', err.message || err);
        }

        if (!info) return;
        this.peerExtendedHandshake = info;
        var name;

        if (typeof info.m === 'object') {
          for (name in info.m) {
            this.peerExtendedMapping[name] = Number(info.m[name].toString());
          }
        }

        for (name in this._ext) {
          if (this.peerExtendedMapping[name]) {
            this._ext[name].onExtendedHandshake(this.peerExtendedHandshake);
          }
        }

        this._debug('got extended handshake');

        this.emit('extended', 'handshake', this.peerExtendedHandshake);
      } else {
        if (this.extendedMapping[ext]) {
          ext = this.extendedMapping[ext]; // friendly name for extension

          if (this._ext[ext]) {
            // there is an registered extension handler, so call it
            this._ext[ext].onMessage(buf);
          }
        }

        this._debug('got extended message ext=%s', ext);

        this.emit('extended', ext, buf);
      }
    }
  }, {
    key: "_onTimeout",
    value: function _onTimeout() {
      this._debug('request timed out');

      this._callback(this.requests.shift(), new Error('request has timed out'), null);

      this.emit('timeout');
    }
    /**
     * Duplex stream method. Called whenever the remote peer has data for us. Data that the
     * remote peer sends gets buffered (i.e. not actually processed) until the right number
     * of bytes have arrived, determined by the last call to `this._parse(number, callback)`.
     * Once enough bytes have arrived to process the message, the callback function
     * (i.e. `this._parser`) gets called with the full buffer of data.
     * @param  {Buffer} data
     * @param  {string} encoding
     * @param  {function} cb
     */

  }, {
    key: "_write",
    value: function _write(data, encoding, cb) {
      this._bufferSize += data.length;

      this._buffer.push(data);

      while (this._bufferSize >= this._parserSize) {
        var buffer = this._buffer.length === 1 ? this._buffer[0] : Buffer.concat(this._buffer);
        this._bufferSize -= this._parserSize;
        this._buffer = this._bufferSize ? [buffer.slice(this._parserSize)] : [];

        this._parser(buffer.slice(0, this._parserSize));
      }

      cb(null); // Signal that we're ready for more data
    }
  }, {
    key: "_callback",
    value: function _callback(request, err, buffer) {
      if (!request) return;

      this._clearTimeout();

      if (!this.peerChoking && !this._finished) this._updateTimeout();
      request.callback(err, buffer);
    }
  }, {
    key: "_clearTimeout",
    value: function _clearTimeout() {
      if (!this._timeout) return;
      clearTimeout(this._timeout);
      this._timeout = null;
    }
  }, {
    key: "_updateTimeout",
    value: function _updateTimeout() {
      var _this4 = this;

      if (!this._timeoutMs || !this.requests.length || this._timeout) return;
      this._timeout = setTimeout(function () {
        return _this4._onTimeout();
      }, this._timeoutMs);
      if (this._timeoutUnref && this._timeout.unref) this._timeout.unref();
    }
    /**
     * Takes a number of bytes that the local peer is waiting to receive from the remote peer
     * in order to parse a complete message, and a callback function to be called once enough
     * bytes have arrived.
     * @param  {number} size
     * @param  {function} parser
     */

  }, {
    key: "_parse",
    value: function _parse(size, parser) {
      this._parserSize = size;
      this._parser = parser;
    }
    /**
     * Handle the first 4 bytes of a message, to determine the length of bytes that must be
     * waited for in order to have the whole message.
     * @param  {Buffer} buffer
     */

  }, {
    key: "_onMessageLength",
    value: function _onMessageLength(buffer) {
      var length = buffer.readUInt32BE(0);

      if (length > 0) {
        this._parse(length, this._onMessage);
      } else {
        this._onKeepAlive();

        this._parse(4, this._onMessageLength);
      }
    }
    /**
     * Handle a message from the remote peer.
     * @param  {Buffer} buffer
     */

  }, {
    key: "_onMessage",
    value: function _onMessage(buffer) {
      this._parse(4, this._onMessageLength);

      switch (buffer[0]) {
        case 0:
          return this._onChoke();

        case 1:
          return this._onUnchoke();

        case 2:
          return this._onInterested();

        case 3:
          return this._onUninterested();

        case 4:
          return this._onHave(buffer.readUInt32BE(1));

        case 5:
          return this._onBitField(buffer.slice(1));

        case 6:
          return this._onRequest(buffer.readUInt32BE(1), buffer.readUInt32BE(5), buffer.readUInt32BE(9));

        case 7:
          return this._onPiece(buffer.readUInt32BE(1), buffer.readUInt32BE(5), buffer.slice(9));

        case 8:
          return this._onCancel(buffer.readUInt32BE(1), buffer.readUInt32BE(5), buffer.readUInt32BE(9));

        case 9:
          return this._onPort(buffer.readUInt16BE(1));

        case 20:
          return this._onExtended(buffer.readUInt8(1), buffer.slice(2));

        default:
          this._debug('got unknown message');

          return this.emit('unknownmessage', buffer);
      }
    }
  }, {
    key: "_parseHandshake",
    value: function _parseHandshake() {
      var _this5 = this;

      this._parse(1, function (buffer) {
        var pstrlen = buffer.readUInt8(0);

        _this5._parse(pstrlen + 48, function (handshake) {
          var protocol = handshake.slice(0, pstrlen);

          if (protocol.toString() !== 'BitTorrent protocol') {
            _this5._debug('Error: wire not speaking BitTorrent protocol (%s)', protocol.toString());

            _this5.end();

            return;
          }

          handshake = handshake.slice(pstrlen);

          _this5._onHandshake(handshake.slice(8, 28), handshake.slice(28, 48), {
            dht: !!(handshake[7] & 0x01),
            // see bep_0005
            extended: !!(handshake[5] & 0x10) // see bep_0010

          });

          _this5._parse(4, _this5._onMessageLength);
        });
      });
    }
  }, {
    key: "_onFinish",
    value: function _onFinish() {
      this._finished = true;
      this.push(null); // stream cannot be half open, so signal the end of it

      while (this.read()) {// body intentionally empty
        // consume and discard the rest of the stream data
      }

      clearInterval(this._keepAliveInterval);

      this._parse(Number.MAX_VALUE, function () {});

      while (this.peerRequests.length) {
        this.peerRequests.pop();
      }

      while (this.requests.length) {
        this._callback(this.requests.pop(), new Error('wire was closed'), null);
      }
    }
  }, {
    key: "_debug",
    value: function _debug() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      args[0] = "[".concat(this._debugId, "] ").concat(args[0]);
      debug.apply(void 0, args);
    }
  }, {
    key: "_pull",
    value: function _pull(requests, piece, offset, length) {
      for (var i = 0; i < requests.length; i++) {
        var req = requests[i];

        if (req.piece === piece && req.offset === offset && req.length === length) {
          arrayRemove(requests, i);
          return req;
        }
      }

      return null;
    }
  }]);

  return Wire;
}(stream.Duplex);

module.exports = Wire;